import React from "react";
/* Import Boostrap */
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import VisibilitySensor from 'react-visibility-sensor';

import CoverHeader from './cover-header';
import Heading1 from '../titles/Heading1';
import Heading2 from '../titles/Heading2';

class CoverHeaderXs extends React.Component { 
    constructor(props) {
        super(props);
        this.state = {
            animated : false,
            animationClasses : [''],
        };
        this.headerVisible = this.headerVisible.bind(this);
    }

    headerVisible(isVisible) {
        if (isVisible) {
            if (!this.state.animated) {
                var classes = this.state.animationClasses;
                classes.push('fadeInUp');
                classes.push('animated-fast');
                this.setState({ animated: true, animationClasses: classes });
            }
        }
    };
    render (){
        return (
                <CoverHeader imageUrl={ this.props.backgroundImage } headerSizeClass={ this.props.headerSizeClass }>
                    <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible }>
                        <Row>
                            <Col className="text-center" md={8} mdOffset={2}>
                                <div className="display-t">
                                    <div className="display-tc">
                                        <Heading1 wait={ 100 } title={ this.props.headerTitle } className={ this.state.animationClasses.join(' ') }/>
                                        { typeof this.props.headerSubTitle !== 'undefined' &&
                                            <Heading2 wait={ 300 } title={ this.props.headerSubTitle } className={ this.state.animationClasses.join(' ') }/>
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </VisibilitySensor>
                </CoverHeader>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(CoverHeaderXs);



// WEBPACK FOOTER //
// ./src/components/header/cover-header-xs.jsx